// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eU0_OPfhsl8n8PaTHQLw {
  padding: 64px 72px;
}

.cZv9qYpRkGjOSnjEwj8r {
  height: 200px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.TFykR3Zl2JtdigvBwh0r {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.rAlMHl5YLFQ8qlHSlNNc {
  text-align: center;
  text-transform: uppercase;
}

.ZhfNfdF08ci1IoQxfOAM:hover {
  cursor: pointer;
}

.wU2qTppJUV_TRW_BR2qZ {
  font-family: var(--font-stack-full-heavy);
  display: flex;
  align-items: center;
  gap: 4px;
}
.wU2qTppJUV_TRW_BR2qZ:hover {
  cursor: pointer;
}

.ktOXWtg4bSy82EDWMtEA {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
  padding: 0 30px 0 40px;
}

.u4W96I0L_FKphNmDnWJN {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}

.a1QPZmXhSkXojRBAhYAK {
  font-size: 20px;
  font-family: var(--font-stack-full-heavy);
}

.TOZBshNkLh9zP1coDGUN:hover {
  cursor: pointer;
}

.VM5war9CmZhbxnoFwNKc {
  font-size: 15px;
  font-family: var(--font-stack-full-book);
}

.Iatx52xdayaDfiQw86p1 {
  margin-bottom: 10px;
}
.Iatx52xdayaDfiQw86p1 label {
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  line-height: 24px;
  color: var(--grey-color-90);
}
.Iatx52xdayaDfiQw86p1 div {
  padding-bottom: 0px !important;
}

.GD3HYGVO6f7kNqzEcOxy, .iFnRvhEmDku5uduhOwBF {
  font-size: 20px;
  font-family: var(--font-stack-full-heavy);
  line-height: 28px;
  color: var(--grey-color-90);
  margin-bottom: 10px;
}

.GD3HYGVO6f7kNqzEcOxy {
  margin-top: 23px;
}

.orho7manWCet_rizZfJg {
  padding: 10px;
}

.kU8vW3Wjd5S9OwWNok4M {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.bdGsOmZYB86sFCihkcAc {
  transform: rotate(-90deg);
  white-space: nowrap;
  text-decoration: underline;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.vaRyfg8ygbc6aRKKhudL {
  white-space: nowrap;
  text-decoration: underline;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.rWsqMHCA6ygJT0bR3sCu {
  cursor: pointer;
}

.Da2YNrP8vA7gTetKWyYV {
  cursor: pointer;
  display: flex;
}

.N5fAIwHxlXUwOE0Ly4Rm {
  position: relative;
  bottom: 90px;
  left: 38px;
  width: 36px;
}
.N5fAIwHxlXUwOE0Ly4Rm svg {
  width: 22px !important;
  height: 22px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/TalentReview/NineBoxSettings.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;AACF;;AAGE;EACE,eAAA;AAAJ;;AAIA;EACE,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AADF;AAGE;EACE,eAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAKA;EACE,eAAA;EACA,yCAAA;AAFF;;AAME;EACE,eAAA;AAHJ;;AAOA;EACE,eAAA;EACA,wCAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;AAME;EACE,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAJJ;AAME;EACE,8BAAA;AAJJ;;AAQA;EACE,eAAA;EACA,yCAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;AALF;;AAYA;EAGE,gBAAA;AAXF;;AAcA;EACE,aAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAXF;;AAcA;EACE,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAXF;;AAaA;EACE,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAVF;;AAaA;EACE,eAAA;AAVF;;AAYA;EACE,eAAA;EACA,aAAA;AATF;;AAYA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AATF;AAUE;EACE,sBAAA;EACA,uBAAA;AARJ","sourcesContent":[".gridContainer {\n  padding: 64px 72px;\n}\n\n.boxContainer {\n  height: 200px;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.boxLabelContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.boxLabel {\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.boxPencilIcon {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.boxEditIcon {\n  font-family: var(--font-stack-full-heavy);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.gridHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 32px;\n  padding: 0 30px 0 40px;\n}\n\n.gridHeaderLabel {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n}\n\n.gridHeaderLabelText {\n  font-size: 20px;\n  font-family: var(--font-stack-full-heavy);\n}\n\n.gridHeaderLabelPencil {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.gridHeaderSubLabel {\n  font-size: 15px;\n  font-family: var(--font-stack-full-book);\n}\n\n.labelEditFormInputWrapper {\n  margin-bottom: 10px;\n\n  label {\n    font-family: var(--font-stack-full-heavy);\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--grey-color-90);\n  }\n  div {\n    padding-bottom: 0px !important;\n  }\n}\n\n%titleStyles {\n  font-size: 20px;\n  font-family: var(--font-stack-full-heavy);\n  line-height: 28px;\n  color: var(--grey-color-90);\n  margin-bottom: 10px;\n}\n\n.labelEditFormSectionTitle {\n  @extend %titleStyles;\n}\n\n.labelEditFormSectionTitleBottom {\n  @extend %titleStyles;\n\n  margin-top: 23px;\n}\n\n.infoBarWrapper {\n  padding: 10px;\n}\n\n.gridSaveWrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n\n.yLabelText {\n  transform: rotate(-90deg);\n  white-space: nowrap;\n  text-decoration: underline;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.xLabelText {\n  white-space: nowrap;\n  text-decoration: underline;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.revertAllIcon {\n  cursor: pointer;\n}\n.revertAllWrapper {\n  cursor: pointer;\n  display: flex;\n}\n\n.iconWrapper {\n  position: relative;\n  bottom: 90px;\n  left: 38px;\n  width: 36px;\n  svg {\n    width: 22px !important;\n    height: 22px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `eU0_OPfhsl8n8PaTHQLw`,
	"boxContainer": `cZv9qYpRkGjOSnjEwj8r`,
	"boxLabelContainer": `TFykR3Zl2JtdigvBwh0r`,
	"boxLabel": `rAlMHl5YLFQ8qlHSlNNc`,
	"boxPencilIcon": `ZhfNfdF08ci1IoQxfOAM`,
	"boxEditIcon": `wU2qTppJUV_TRW_BR2qZ`,
	"gridHeader": `ktOXWtg4bSy82EDWMtEA`,
	"gridHeaderLabel": `u4W96I0L_FKphNmDnWJN`,
	"gridHeaderLabelText": `a1QPZmXhSkXojRBAhYAK`,
	"gridHeaderLabelPencil": `TOZBshNkLh9zP1coDGUN`,
	"gridHeaderSubLabel": `VM5war9CmZhbxnoFwNKc`,
	"labelEditFormInputWrapper": `Iatx52xdayaDfiQw86p1`,
	"labelEditFormSectionTitleBottom": `GD3HYGVO6f7kNqzEcOxy`,
	"labelEditFormSectionTitle": `iFnRvhEmDku5uduhOwBF`,
	"infoBarWrapper": `orho7manWCet_rizZfJg`,
	"gridSaveWrapper": `kU8vW3Wjd5S9OwWNok4M`,
	"yLabelText": `bdGsOmZYB86sFCihkcAc`,
	"xLabelText": `vaRyfg8ygbc6aRKKhudL`,
	"revertAllIcon": `rWsqMHCA6ygJT0bR3sCu`,
	"revertAllWrapper": `Da2YNrP8vA7gTetKWyYV`,
	"iconWrapper": `N5fAIwHxlXUwOE0Ly4Rm`
};
export default ___CSS_LOADER_EXPORT___;
